// Existing portrait assets matched to November candidate names.
// This registry supplies images only; race membership and party come from November ballots.
// Jason L Powell is printed without the middle-initial period on the November ballot.
const novemberCandidatePortraits = {
  "Aftyn Behn": {
    "src": "/candidate_photos/aftyn-behn.png"
  },
  "Antonio Parkinson": {
    "src": "/candidate_photos/antonio-parkinson.jpg"
  },
  "Bill Hagerty": {
    "src": "/candidate_photos/bill-hagerty.jpg"
  },
  "Bo Mitchell": {
    "src": "/candidate_photos/bo-mitchell.png"
  },
  "Bo Watson": {
    "src": "/candidate_photos/bo-watson.png"
  },
  "Bob Freeman": {
    "src": "/candidate_photos/bob-freeman.png"
  },
  "Brent Taylor": {
    "src": "/candidate_photos/brent-taylor.jpg"
  },
  "Bryan Langan": {
    "src": "/candidate_photos/bryan-langan.webp"
  },
  "Charlane Oliver": {
    "src": "/candidate_photos/charlane-oliver.png"
  },
  "Chuck Fleischmann": {
    "src": "/candidate_photos/chuck-fleischmann.jpg"
  },
  "Dave Wright": {
    "src": "/candidate_photos/dave-wright.jpg"
  },
  "David Miller": {
    "src": "/candidate_photos/david-miller-crop.jpg"
  },
  "Elaine Davis": {
    "src": "/candidate_photos/elaine-davis.png"
  },
  "Esther Helton Haynes": {
    "src": "/candidate_photos/esther-helton-haynes.png"
  },
  "Gloria Johnson": {
    "src": "/candidate_photos/gloria-johnson.jpg"
  },
  "Greg Martin": {
    "src": "/candidate_photos/greg-martin.png"
  },
  "Greg Vital": {
    "src": "/candidate_photos/greg-vital.png"
  },
  "Harold M. Love, Jr.": {
    "src": "/candidate_photos/harold-love.png"
  },
  "Jason L Powell": {
    "src": "/candidate_photos/jason-powell.png"
  },
  "Jason Zachary": {
    "src": "/candidate_photos/jason-zachary.jpg"
  },
  "Jeff Yarbro": {
    "src": "/candidate_photos/jeff-yarbro.png"
  },
  "Jerri Green": {
    "src": "/candidate_photos/jerri-green-crop.jpg"
  },
  "Jesse Chism": {
    "src": "/candidate_photos/jesse-chism.jpg"
  },
  "John Gillespie": {
    "src": "/candidate_photos/john-gillespie.jpg"
  },
  "John Ray Clemmons": {
    "src": "/candidate_photos/john-ray-clemmons.png"
  },
  "Johnny Garrett": {
    "src": "/candidate_photos/johnny-garrett.png"
  },
  "Justin J. Pearson": {
    "src": "/candidate_photos/justin-pearson.jpg"
  },
  "Justin Jones": {
    "src": "/candidate_photos/justin-jones.png"
  },
  "Justin Lafferty": {
    "src": "/candidate_photos/justin-lafferty.jpg"
  },
  "Karen Camper": {
    "src": "/candidate_photos/karen-camper.jpg"
  },
  "Kevin Vaughan": {
    "src": "/candidate_photos/kevin-vaughan.jpg"
  },
  "Larry J. Miller": {
    "src": "/candidate_photos/larry-miller.jpg"
  },
  "London Lamar": {
    "src": "/candidate_photos/london-lamar.jpg"
  },
  "Mark Pody": {
    "src": "/candidate_photos/mark-pody.png"
  },
  "Mark White": {
    "src": "/candidate_photos/mark-white.jpg"
  },
  "Marquita Bradshaw": {
    "src": "/candidate_photos/marquita-bradshaw.jpg"
  },
  "Marsha Blackburn": {
    "src": "/candidate_photos/marsha-blackburn-crop.jpg"
  },
  "Matt Van Epps": {
    "src": "/candidate_photos/matt-van-epps.webp"
  },
  "Michaela Barnett": {
    "src": "/candidate_photos/michaela-barnett.jpg",
    "position": "50% 32%"
  },
  "Michele Carringer": {
    "src": "/candidate_photos/michele-carringer.jpg"
  },
  "Michele Reneau": {
    "src": "/candidate_photos/michele-reneau.png"
  },
  "Raumesh Akbari": {
    "src": "/candidate_photos/raumesh-akbari.jpg"
  },
  "Richard M. Briggs": {
    "src": "/candidate_photos/richard-briggs.jpg"
  },
  "Sam McKenzie": {
    "src": "/candidate_photos/sam-mckenzie.jpg"
  },
  "Scott DesJarlais": {
    "src": "/candidate_photos/scott-desjarlais.jpg"
  },
  "Shaundelle Brooks": {
    "src": "/candidate_photos/shaundelle-brooks.png"
  },
  "Tim Burchett": {
    "src": "/candidate_photos/tim-burchett.jpg"
  },
  "Tom Leatherwood": {
    "src": "/candidate_photos/tom-leatherwood.jpg"
  },
  "Torrey C. Harris": {
    "src": "/candidate_photos/torrey-harris.jpg"
  },
  "Vincent Dixie": {
    "src": "/candidate_photos/vincent-dixie.png"
  },
  "Yusuf A. Hakeem": {
    "src": "/candidate_photos/yusuf-hakeem.png"
  }
};

export default novemberCandidatePortraits;
